import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { OnlineSalesCardData } from "../../../../Data/General/Widgets/General";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";
import { H4 } from "../../../../AbstractElements";
import { Fragment } from "react/jsx-runtime";

const OnlineSalesCard = () => {
  return (
    <Fragment>
      {OnlineSalesCardData.map((item, index) => (
        <Col xxl="2" md="4" className={`box-col-4 ${index  <=1 ? "col-sm-6" : "col-sm-5"}`} key={index}>
          <Card className="online-order">
            <CardHeader className="pb-0">
              <div className="d-flex">
                <div className={`order bg-light-${item.color}`}>
                  <SvgIcon iconId={item.icon} />
                </div>
                <div className="arrow-chart">
                  <SvgIcon iconId={item.arrowChart} />
                  <span className={`font-${item.arrowColor}`}>{item.text}</span>
                </div>
              </div>
              <div className="online">
                <span>{item.title}</span>
                <H4><CountUp end={item.endValue} className="num-counter" delay={0} /></H4>
              </div>
            </CardHeader>
            <CardBody className="pt-0 ps-2 pe-2">
              <div id="online-chart" className={item.chartClass}>
                <ReactApexChart options={item.chart} series={item.chart.series} height={item.chart.chart?.height} type={item.chart.chart?.type} />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};

export default OnlineSalesCard;
